module.exports = __webpack_public_path__ + "static/media/QUOTE2.dc69f7d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/QUOTE2.png
// module id = 275
// module chunks = 0